// import {Injectable} from '@angular/core';
// import SecureLS from "secure-ls";
//
// @Injectable({
//   providedIn: 'root'
// })
// export class StorageService {
//
//   private ls = new SecureLS({ encodingType: 'aes', isCompression: true });
//
//   constructor() { }
//
//   set(key: string, value: any, expired: number = 0) {
//     this.ls.set(key, value);
//   }
//
//   remove(key: string) {
//     this.ls.remove(key);
//   }
//
//   get(key: string) {
//     return this.ls.get(key);
//   }
//
//   clear() {
//     this.ls.removeAll();
//   }
// }
// import { Injectable } from '@angular/core';
// import SecureLS from 'secure-ls';
//
// @Injectable({
//   providedIn: 'root',
// })
// export class StorageService {
//   private ls = new SecureLS({ encodingType: 'aes', isCompression: true });
//
//   constructor() {}
//
//   set(key: string, value: any): void {
//     try {
//       if (value === undefined || value === null) {
//         this.ls.remove(key);
//       } else {
//         this.ls.set(key, value);
//       }
//     } catch (error) {
//       console.error(`Error setting key ${key}:`, error);
//     }
//   }
//
//   get<T = any>(key: string): T | null {
//     try {
//       // Check raw localStorage first to avoid SecureLS crash
//       const raw = localStorage.getItem(key);
//       if (raw === null) {
//         return null; // key does not exist
//       }
//
//       // Let SecureLS decode only if it exists
//       const data = this.ls.get(key);
//       return data !== null && data !== undefined ? (data as T) : null;
//     } catch (error) {
//       console.error(`Error getting key ${key}:`, error);
//       return null;
//     }
//   }
//
//   remove(key: string): void {
//     try {
//       this.ls.remove(key);
//     } catch (error) {
//       console.error(`Error removing key ${key}:`, error);
//     }
//   }
//
//   clear(): void {
//     try {
//       this.ls.removeAll();
//     } catch (error) {
//       console.error(`Error clearing storage:`, error);
//     }
//   }
// }

import { Injectable } from '@angular/core';
import SecureLS from 'secure-ls';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  // Initialize SecureLS with AES encoding and compression
  private ls = new SecureLS({ encodingType: 'aes', isCompression: true });

  constructor() {}

  /**
   * Sets a key-value pair in secure local storage.
   * If value is null or undefined, the key is removed.
   */
  set(key: string, value: any): void {
    try {
      if (value === undefined || value === null) {
        this.ls.remove(key);
      } else {
        this.ls.set(key, value);
      }
    } catch (error) {
      console.error(`Error setting key ${key}:`, error);
    }
  }

  /**
   * Retrieves data from secure local storage.
   * Includes a critical catch block to handle and clear corrupted data.
   */
  get<T = any>(key: string): T | null {
    try {
      // NOTE: Checking raw localStorage first is redundant with SecureLS and can be removed,
      // as the core error occurs during SecureLS's internal read/decode process.
      // We rely solely on the SecureLS read below.

      const data = this.ls.get(key);

      // SecureLS often returns null or an empty string on failure or absence.
      return data !== null && data !== undefined ? (data as T) : null;
    } catch (error) {
      // CRITICAL FIX: If SecureLS fails (due to Malformed UTF-8 or failed JSON parsing),
      // we must assume the data for this key is corrupted and delete it.
      // This prevents the application from repeatedly crashing on startup.
      console.error(
        `Error getting key ${key}: Malformed or corrupted data detected. Clearing key to recover.`,
        error
      );
      this.ls.remove(key);
      return null;
    }
  }

  /**
   * Removes a specific key from storage.
   */
  remove(key: string): void {
    try {
      this.ls.remove(key);
    } catch (error) {
      console.error(`Error removing key ${key}:`, error);
    }
  }

  /**
   * Clears all keys managed by SecureLS.
   */
  clear(): void {
    try {
      this.ls.removeAll();
    } catch (error) {
      console.error(`Error clearing storage:`, error);
    }
  }
}
